import React from 'react';
import { ColDef } from 'ag-grid-community';
import { MaterialDimension } from '../types/CommonTypes';
import ConditionList from './ConditionList';

interface Props {
    dimensions: MaterialDimension[];
    onSelect: (dimension: MaterialDimension) => void;
    loading?: boolean;
}

const columnDefs: ColDef<MaterialDimension>[] = [
    { headerName: 'Code', field: 'code', flex: 60 },
    { headerName: 'Legacy Code', field: 'legacyCode', flex: 60 },
    { headerName: 'Definition', field: 'dimensionDefinition', flex: 120 },
    { headerName: 'Value', field: 'dimensionValue', flex: 60 },
    { headerName: 'Unit', field: 'dimensionUnit', flex: 60 },
];

export default function DimensionList({ dimensions, onSelect, loading }: Props): JSX.Element {
    return <ConditionList rows={dimensions} columnDefs={columnDefs} onSelect={onSelect} loading={loading} />;
}
